// test2388
(2388 && 0);
